import { lazy } from 'react';

const BuyIndex = lazy(() => import('../pages/sourcing/main/index'));
// const Buyers = lazy(() => import('@/pages/buyers/index'));
//询价采购
const InquiryPurchase = lazy(() => import('../pages/sourcing/inquiryPurchase'));
const InquiryPurchaseAdd = lazy(() => import('@/pages/sourcing/inquiryPurchase/add'));
const InquiryPurchaseDetail = lazy(() => import('@/pages/sourcing/inquiryPurchase/detail'));
const InquiryPurchaseFeedbackInfo = lazy(() => import('@/pages/sourcing/inquiryPurchase/info'));

//竞价列表
const PurchaseRace = lazy(() => import('@/pages/sourcing/purchaseRace'));
const PurchaseRaceCreate = lazy(() => import('@/pages/sourcing/purchaseRace/add'));
const PurchaseRaceDetail = lazy(() => import('@/pages/sourcing/purchaseRace/detail'));
const PurchaseRaceFeedbackInfo = lazy(() => import('@/pages/sourcing/purchaseRace/feedbackInfo'));

//商品寻源
const ProductInquiry = lazy(() => import('@/pages/sourcing/productInquiry'));
const ProductInquiryAdd = lazy(() => import('@/pages/sourcing/productInquiry/add'));
const ProductInquiryDetail = lazy(() => import('@/pages/sourcing/productInquiry/detail'));
const ProductInquiryFeedbackInfo = lazy(() => import('@/pages/sourcing/productInquiry/feedbackInfo'));

// 供应商审批
const SupplierVerifyList = lazy(() => import('../pages/supplierVerify/index'));
const SupplierInvitation = lazy(() => import('../pages/supplierVerify/invitation'));
const SupplierVerifyDetail = lazy(() => import('../pages/supplierVerify/detail/index'));
const SupplierVerifyOldDetail = lazy(() => import('../pages/supplierVerify/olddetail/index'));
const SupplierVerify = lazy(() => import('../pages/supplierVerify/approval'));
const SupplierVariety = lazy(() => import('../pages/supplierVerify/variety'));
const SupplierOldVerify = lazy(() => import('../pages/supplierVerify/detailVerify'));

// 供应商管理
const SupplierList = lazy(() => import('../pages/supplierManage'));
const SupplierDetail = lazy(() => import('../pages/supplierManage/detail'));
const SupplierRelation = lazy(() => import('../pages/buyers/supplierRelation/list'));
const SupplierRelationDetail = lazy(() => import('../pages/buyers/supplierRelation/detail'));
const SupplierRelationCreate = lazy(() => import('../pages/buyers/supplierRelation/create'));

// 绩效管理
const KpiList = lazy(() => import('../pages/supplierKpi'));
const KpiDetail = lazy(() => import('../pages/supplierKpi/detail'));

// 招投标管理
const TenderManage = lazy(() => import('../pages/tenderManage/list'));
const NewTender = lazy(() => import('../pages/tenderManage/new'));
const TenderManageDetail = lazy(() => import('../pages/tenderManage/detail'));
const TenderSupplierDetail = lazy(() => import('../pages/tenderManage/component/supplier/detail'));
const TenderVarifyDetail = lazy(() => import('../pages/tenderManage/varify/detail'));
const TenderVarifyDetailScore = lazy(() => import('../pages/tenderManage/varify/score')); //
const TenderEvaluate = lazy(() => import('../pages/tenderManage/evaluate')); // 评标评分
const TenderCalibration = lazy(() => import('../pages/tenderManage/calibration/index')); // 评标评分
const TenderPublic = lazy(() => import('../pages/tenderManage/publish')); // 中标公示
const TenderRecords = lazy(() => import('../pages/tenderManage/component/approveRecords')); // 初审评分记录

//计划单
const PlanList = lazy(() => import('../pages/plan/list/index'));
const PlanDetail = lazy(() => import('../pages/plan/detail/index'));

//单据
const PurchaseDocument = lazy(() => import('../pages/documents/purchase/index'));
const AddTemplate = lazy(() => import('../pages/documents/purchase/AddTemplate'));

const BuyerPriceCenter = lazy(() => import('../pages/priceCenter/Buyer/index'));
const BuyerPoultryList = lazy(() => import('../pages/priceCenter/Buyer/poultry'));

const PurchaseOrderList = lazy(() => import('../pages/order/purchase/list'));
const PurchaseOrderDetail = lazy(() => import('../pages/order/purchase/detail'));

export const buyersRouters = [
  {
    path: '/buyers/front',
    element: <BuyIndex />,
    key: 'buyersIndex',
    label: 'Buyer Center',
    handle: { menuKey: 'buyersIndex', parentKey: '' },
    hidden: false
  },
  {
    // path: '/buyers',
    key: 'inquiry',
    label: 'Request for Quotation',
    children: [
      {
        path: '/buyers/inquirypurchase',
        element: <InquiryPurchase />,
        key: 'inquiryPurchase',
        label: 'Inquiry Purchasing',
        handle: { menuKey: 'inquiryPurchase', parentKey: 'inquiry' },
        hidden: false,
        parentKey: 'inquiry',
      },
      {
        path: '/buyers/inquirypurchase/add/:inquiry_no?',
        element: <InquiryPurchaseAdd />,
        key: 'inquiryPurchaseAdd',
        label: '询价采购添加',
        handle: { menuKey: 'inquiryPurchase', parentKey: 'inquiry' },
        hidden: true,
        parentKey: 'inquiry',
      },

      {
        path: '/buyers/inquirypurchase/detail/:inquiry_no',
        element: <InquiryPurchaseDetail />,
        key: 'inquiryPurchaseDetail',
        label: '询价采购详情',
        handle: { menuKey: 'inquiryPurchase', parentKey: 'inquiry' },
        hidden: true,
        parentKey: 'inquiry',
      },
      {
        path: '/buyers/inquirypurchase/feedback/detail/:inquiry_feedback_no',
        element: <InquiryPurchaseFeedbackInfo />,
        key: 'inquiryPurchaseFeedbackInfo',
        label: '询价采购报价单详情',
        handle: { menuKey: 'inquiryPurchase', parentKey: 'inquiry' },
        hidden: true,
        parentKey: 'inquiry',
      },
      {
        path: '/buyers/purchaserace',
        element: <PurchaseRace />,
        key: 'purchaseRace',
        label: 'Bidding Purchase',
        handle: { menuKey: 'purchaseRace', parentKey: 'inquiry' },
        hidden: false,
        parentKey: 'inquiry',
      },
      {
        path: '/buyers/purchaserace/add',
        element: <PurchaseRaceCreate />,
        key: 'purchaseRaceAdd',
        label: '竞价采购添加',
        handle: { menuKey: 'purchaseRace', parentKey: 'inquiry' },
        hidden: true,
        parentKey: 'inquiry',
      },
      {
        path: '/buyers/purchaserace/detail/:race_no/:status',
        element: <PurchaseRaceDetail />,
        key: 'purchaseRaceDetail',
        label: '竞价采购详情',
        handle: { menuKey: 'purchaseRace', parentKey: 'inquiry' },
        hidden: true,
        parentKey: 'inquiry',
      },
      {
        path: '/buyers/purchaserace/feedback/detail/:race_feedback_no',
        element: <PurchaseRaceFeedbackInfo />,
        key: 'purchaseRaceFeedbackInfo',
        label: '竞价采购报价单详情',
        handle: { menuKey: 'purchaseRace', parentKey: 'inquiry' },
        hidden: true,
        parentKey: 'inquiry',
      },
      {
        path: '/buyers/productinquiry',
        element: <ProductInquiry />,
        key: 'productInquiry',
        label: 'Commodity Sourcing',
        handle: { menuKey: 'productInquiry', parentKey: 'inquiry' },
        hidden: false,
        parentKey: 'inquiry',
      },
      {
        path: '/buyers/productinquiry/detail/:origin_no',
        element: <ProductInquiryDetail />,
        key: 'productInquiryDetail',
        label: '商品寻源详情',
        handle: { menuKey: 'productInquiry', parentKey: 'inquiry' },
        hidden: true,
        parentKey: 'inquiry',
      },
      {
        path: '/buyers/productinquiry/add',
        element: <ProductInquiryAdd />,
        key: 'productInquiryAdd',
        label: '商品寻源添加',
        handle: { menuKey: 'productInquiry', parentKey: 'inquiry' },
        hidden: true,
        parentKey: 'inquiry',
      },
      {
        path: '/buyers/productinquiry/feedback/detail/:origin_feedback_no',
        element: <ProductInquiryFeedbackInfo />,
        key: 'productInquiryFeedbackInfo',
        label: '商品寻源报价单详情',
        handle: { menuKey: 'productInquiry', parentKey: 'inquiry' },
        // hidden: true,
        parentKey: 'inquiry',
      },

    ]
  },
  {
    // path: '/buyers',
    key: 'supplier',
    label: 'Supplier Management', //供应商管理,
    children: [
      {
        path: '/buyers/supplierInvitation/list',
        element: <SupplierInvitation />,
        key: 'supplierInvitation',
        label: 'Supplier Invitation', //供应商邀请
        handle: { menuKey: 'supplierInvitation', parentKey: 'supplier' },
        hidden: false,
        parentKey: 'supplier'
      },
      {
        path: '/buyers/supplierVerify/list',
        element: <SupplierVerifyList />,
        key: 'supplierVerifyList',
        label: 'Supplier Verification', //供应商管理
        handle: { menuKey: 'supplierVerifyList', parentKey: 'supplier' },
        hidden: false,
        parentKey: 'supplier'
      },
      {
        path: '/buyers/supplierVerify/list/detail/:id/:approval_no/:company_id?',
        element: <SupplierVerifyDetail />,
        key: 'supplierVerifyDetail',
        label: '查看详情', //供应商管理详情
        handle: { menuKey: 'supplierVerifyList', parentKey: 'supplier' },
        hidden: true,
        parentKey: 'supplier'
      },
      {
        path: '/buyers/supplierVerify/list/olddetail/:id/:approval_no/:company_id?',
        element: <SupplierVerifyOldDetail />,
        key: 'supplierVerifyOldDetail',
        label: '查看详情', //供应商管理详情
        handle: { menuKey: 'supplierVerifyList', parentKey: 'supplier' },
        hidden: true,
        parentKey: 'supplier'
      },
      {
        path: '/buyers/supplierVerify/list/verify/:id/:approval_no/:company_id',
        element: <SupplierVerify />,
        key: 'supplierVerify',
        label: '供应商审批详情', //供应商管理详情
        handle: { menuKey: 'supplierVerifyList', parentKey: 'supplier' },
        hidden: true,
        parentKey: 'supplier'
      },
      {
        path: '/buyers/supplierVerify/list/variety',
        element: <SupplierVariety />,
        key: 'supplierVariety',
        label: '授信与账期变更/新增记录', //授信与账期变更/新增记录
        handle: { menuKey: 'supplierVerifyList', parentKey: 'supplier' },
        hidden: true,
        parentKey: 'supplier'
      },
      {
        path: '/buyers/supplierVerify/list/oldverify/:id/:approval_no/:company_id',
        element: <SupplierOldVerify />,
        key: 'supplierOldVerify',
        label: '供应商审批详情', //供应商管理详情
        handle: { menuKey: 'supplierVerifyList', parentKey: 'supplier' },
        hidden: true,
        parentKey: 'supplier'
      },
      {
        path: '/buyers/supplier/list',
        element: <SupplierList />,
        key: 'supplierListManage',
        label: 'Supplier Management', //供应商管理
        handle: { menuKey: 'supplierListManage', parentKey: 'supplier' },
        hidden: false,
        parentKey: 'supplier'
      },
      {
        path: '/buyers/supplier/list/:tag',
        element: <SupplierList />,
        key: 'supplierListManageTag',
        label: 'Supplier Management', //供应商管理
        handle: { menuKey: 'supplierListManage', parentKey: 'supplier' },
        hidden: false,
        parentKey: 'supplier'
      },
      {
        path: '/buyers/supplier/list/detail/:status/:supplier_id/:cooperation_id',
        element: <SupplierDetail />,
        key: 'supplierListManageDetail',
        label: '供应商管理详情', //供应商管理详情
        handle: { menuKey: 'supplierListManage', parentKey: 'supplier' },
        hidden: true,
        parentKey: 'supplier'
      },
      {
        path: '/buyers/supplier/kpi/list',
        element: <KpiList />,
        key: 'supplierKpi',
        label: 'Supplier Performance', //供应商绩效
        handle: { menuKey: 'supplierKpi', parentKey: 'supplier' },
        hidden: false,
        parentKey: 'supplier'
      },
      {
        path: '/buyers/supplier/kpi/list/detail/:id',
        element: <KpiDetail />,
        key: 'supplierKpiDetail',
        label: '供应商绩效详情', //供应商绩效详情
        handle: { menuKey: 'supplierKpi', parentKey: 'supplier' },
        hidden: true,
        parentKey: 'supplier'
      },
      {
        path: '/buyers/supplier/relation/list',
        element: <SupplierRelation />,
        key: 'companyRelationManager',
        label: 'Company Relation Management', //关联关系管理
        handle: { menuKey: 'companyRelationManager', parentKey: 'supplier' },
        hidden: false,
        parentKey: 'supplier'
      },
      {
        path: '/buyers/supplier/relation/list/detail',
        element: <SupplierRelationDetail />,
        key: 'companyRelationManagerDetail',
        label: '查看详情',
        handle: { menuKey: 'companyRelationManager', parentKey: 'supplier' },
        hidden: true,
        parentKey: 'supplier'
      },
      {
        path: '/buyers/supplier/relation/list/create',
        element: <SupplierRelationCreate />,
        key: 'companyRelationManagerCreate',
        label: '创建关联',
        handle: { menuKey: 'companyRelationManager', parentKey: 'supplier' },
        hidden: true,
        parentKey: 'supplier'
      }
    ]
  },
  {
    // path: '/buyers',
    key: 'tender',
    label: 'Tender Management', // '招投标管理',
    children: [
      {
        path: '/buyers/tender/list',
        element: <TenderManage />,
        key: 'tenderList',
        label: 'Tender Management', // 招投标管理
        handle: { menuKey: 'tenderList', parentKey: 'tender' },
        hidden: false,
        parentKey: 'tender'
      },
      // {
      //   path: '/buyers/tender/list/add',
      //   element: <NewTender />,
      //   key: 'tenderListAdd',
      //   label: '新建项目',
      //   hidden: true,
      //   parentKey: 'tender'
      // },
      {
        path: '/buyers/tender/list/add/:id?/:is_edit?',
        element: <NewTender />,
        key: 'tenderListCopy',
        label: '复制项目',
        handle: { menuKey: 'tenderList', parentKey: 'tender' },
        hidden: true,
        parentKey: 'tender'
      },
      {
        path: '/buyers/tender/list/view/:id/:status?',
        element: <TenderManageDetail />,
        key: 'tenderListView',
        label: '查看项目',
        handle: { menuKey: 'tenderList', parentKey: 'tender' },
        hidden: true,
        parentKey: 'tender'
      },
      {
        path: '/buyers/tender/list/view/supplierDetail/:id',
        element: <TenderSupplierDetail />,
        key: 'tenderSupplierDetail',
        label: '供应商详情',
        handle: { menuKey: 'tenderList', parentKey: 'tender' },
        hidden: true,
        parentKey: 'tender'
      },
      {
        path: '/buyers/tender/list/TenderManageVarifyDetail/:id',
        element: <TenderVarifyDetail />,
        key: 'tenderSupplierVarifyDetail',
        label: '初审评分',
        handle: { menuKey: 'tenderList', parentKey: 'tender' },
        hidden: true,
        parentKey: 'tender'
      },
      {
        path: '/buyers/tender/list/TenderVarifyDetailScore/:id/:row_id',
        element: <TenderVarifyDetailScore />,
        key: 'tenderVarifyDetailScore',
        label: '评审打分',
        handle: { menuKey: 'tenderList', parentKey: 'tender' },
        hidden: true,
        parentKey: 'tender'
      },
      {
        path: '/buyers/tender/list/TenderManageEvaluate/:id',
        element: <TenderEvaluate />,
        key: 'tenderSupplierEvaluate',
        label: '评标评分',
        handle: { menuKey: 'tenderList', parentKey: 'tender' },
        hidden: true,
        parentKey: 'tender'
      },
      {
        path: '/buyers/tender/list/tenderCalibration/:id',
        element: <TenderCalibration />,
        key: 'tenderCalibration',
        label: '定标评分',
        handle: { menuKey: 'tenderList', parentKey: 'tender' },
        hidden: true,
        parentKey: 'tender'
      },
      {
        path: '/buyers/tender/list/tenderPublic/:id',
        element: <TenderPublic />,
        key: 'tenderSupplierPublic',
        label: '中标公示',
        handle: { menuKey: 'tenderList', parentKey: 'tender' },
        hidden: true,
        parentKey: 'tender'
      },
      {
        path: '/buyers/tender/approve/records/:id/:status',
        element: <TenderRecords />,
        key: 'tenderSupplierEvaluate',
        label: '初审评分记录',
        handle: { menuKey: 'tenderList', parentKey: 'tender' },
        hidden: true,
        parentKey: 'tender'
      },
    ]
  },
  {
    // path: '/buyers',
    key: 'planManagement',
    label: 'Procurement Plan Management', //采购计划管理
    children: [
      {
        path: '/buyers/plan/list',
        element: <PlanList />,
        key: 'planList',
        parentKey: 'planManagement',
        label: 'Plan List', // '计划单列表',
        handle: { menuKey: 'planList', parentKey: 'planManagement' },
      },
      {
        path: '/buyers/plan/list/detail/:order_no',
        element: <PlanDetail />,
        key: 'planDetail',
        parentKey: 'planManagement',
        label: 'Plan Detail', // '计划单详情',
        handle: { menuKey: 'planList', parentKey: 'planManagement' },
        hidden: true,
      }
    ]
  },
  {
    // path: '/buyers',
    key: 'importDocuments',
    label: 'Import and Export Documents', //进出口单据管理
    children: [
      {
        path: '/buyers/purchasedocument/list',
        element: <PurchaseDocument />,
        key: 'importList',
        parentKey: 'importDocuments',
        label: 'Import Documents', // ,
        handle: { menuKey: 'importList', parentKey: 'importDocuments' },
      },
      {
        path: '/buyers/purchasedocument/list/add/:id/:template_id/:name?/:inquiry_no?/:cat_id?',
        element: <AddTemplate />,
        key: 'importAdd',
        parentKey: 'importDocuments',
        label: 'Import Documents',
        handle: { menuKey: 'importList', parentKey: 'importDocuments' },
      },
      {
        path: '/buyers/purchasedocument/list/edit/:id/:template_id/:name?/:inquiry_no?',
        element: <AddTemplate />,
        key: 'importAdd',
        parentKey: 'importDocuments',
        label: 'Import Documents',
        handle: { menuKey: 'importList', parentKey: 'importDocuments' },
      },
      {
        path: '/buyers/purchasedocument/list/view/:id/:template_id/:name?/:inquiry_no?',
        element: <AddTemplate />,
        key: 'importAdd',
        parentKey: 'importDocuments',
        label: 'Import Documents',
        handle: { menuKey: 'importList', parentKey: 'importDocuments' },
      },
    ]
  },
  {
    // path: '/buyers',
    key: 'priceCenter',
    label: 'Price Center',
    children: [
      {
        path: '/buyers/price/list',
        element: <BuyerPriceCenter />,
        key: 'porkPriceIncreaseReport',
        parentKey: 'priceCenter',
        label: 'Pork Price Report',
        handle: { menuKey: 'porkPriceIncreaseReport', parentKey: 'priceCenter' },
      },
      {
        path: '/buyers/poultry/list',
        element: <BuyerPoultryList />,
        key: 'buyerPoultryList',
        parentKey: 'priceCenter',
        label: 'Poultry Price Report',
        handle: { menuKey: 'buyerPoultryList', parentKey: 'priceCenter' },
      },
    ]
  },
  {
    // path: '/buyers',
    key: 'orderManagement',
    label: 'Order Management', //订单管理
    children: [
      {
        path: '/buyers/order/purchase/list',
        element: <PurchaseOrderList />,
        key: 'purchaseOrderManagement',
        parentKey: 'orderManagement',
        label: 'Purchase Order Management', // '采购单管理',
        handle: { menuKey: 'purchaseOrderManagement', parentKey: 'orderManagement' },
      },
      {
        path: '/buyers/order/purchase/list/detail/:order_no',
        element: <PurchaseOrderDetail />,
        key: 'purchaseOrderDetails',
        parentKey: 'orderManagement',
        label: 'Purchase Order Details', // '采购单详情',
        handle: { menuKey: 'purchaseOrderManagement', parentKey: 'orderManagement' },
        hidden: true,
      }
    ]
  },
];